import { SelectItem } from "@mantine/core";

export const CLIENT_ROUTE = '/contact';
export const API_ROUTE = '/api/contact';
export const CLIENT_TITLE = 'Холбоо барих';

export type IContactType = 'location' | 'text' | 'link' | 'phone' | 'email';

interface IContactTypeOption extends Omit<SelectItem, 'value'> {
    value: IContactType;
}

export const contactTypes: IContactTypeOption[] = [
    { value: 'location', label: 'Байршил' },
    { value: 'text', label: 'Текст' },
    { value: 'link', label: 'Холбоос' },
    { value: 'phone', label: 'Утас' },
    { value: 'email', label: 'Имэйл' },
];